import React from 'react'
import { withRouter } from 'react-router'
import { connect } from "react-redux"
import {
  setTitle,
  setUserAsOwner,
  fetchPracticeTypes
} from "../../actions/index";

const saveStyle = {
    'zIndex': 2,
    'position': 'relative'
}

@connect(store => {
  return {
    User: store.User.User,
    practice_types: [...store.practice_types]
  };
})
class RegisterPage extends React.Component {
  constructor({ router, dispatch }) {
    super();
    this.handleInputChange = this.handleInputChange.bind(this);
    this.state = {
      practice: {}
    };
    this.dispatch = dispatch;
    this.router = router;
    this.save = this.save.bind(this);
  }

  componentDidMount() {
    this.dispatch(setTitle("Register your practice"));
    // this.props.dispatch(fetchPracticeTypes());
  }

  save() {
    const { dispatch, router } = this.props;
    const { practice } = this.state;
    dispatch(setUserAsOwner(practice)).then(action => {
      router.push(`/practice_admin/${action.payload._id}/getting_started`);
    });
  }

  disabled() {
    const { practice } = this.state;
    const { User } = this.props;

    if (User.admin && practice.name && practice.name !== "") {
      return false;
    }

    return (
      !practice.name ||
      practice.name === "" ||
      !practice.HPCSA || practice.HPCSA === "" ||
      ((!practice.phone || practice.phone === "") &&
        (!practice.mobile || practice.mobile === "")) ||
      !practice.address1 || practice.address1 === "" ||
      !practice.city || practice.city === "" ||
      !practice.state || practice.state === "" ||
      !practice.postCode || practice.postCode === "" ||
      !practice.country || practice.country === ""
    );
  }

  handleInputChange(e, field) {
    const { practice } = this.state;
    this.setState({
      practice: { ...practice, [field]: e.target.value }
    });
  }

  handlePracticeTypeChange(event, type){
      console.log(event.target.value)
       const { practice } = this.state;
      this.setState({
        practice: { ...practice, [type]: event.target.value }
      });
  }

  render() {
    const { practice } = this.state;

    return (
      <div className="page registerPage">
        <div className="md-body1 form-field">
          <label>Practice Healthcare Profession *</label>
          <div>
            <select
              className="md-input md-title"
              value={practice.practice_type}
              onChange={ e => this.handlePracticeTypeChange(e, "practice_type")}
            >
              {this.props.practice_types.map(type => (
                <option key={type.id} value={type.id}>
                  {type.practice_type}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="md-body1 form-field">
          <label>Practice Name *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "name")}
              value={practice.name}
              type="text"
              placeholder="Name of Practice"
            />
          </div>
        </div>

        <div className="md-body1 form-field">
          <label>HPCSA Number *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "HPCSA")}
              value={practice.HPCSA}
              type="text"
              placeholder="HPCSA Number"
            />
          </div>
        </div>

        <h5>Contacts</h5>

        <div className="md-body1 form-field">
          <label>
            Phone{" "}
            <p>
              <small>Please phone and/or mobile</small>
            </p>
          </label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "phone")}
              value={practice.phone}
              type="text"
              placeholder="Phone"
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>
            Mobile{" "}
            <p>
              <small>Please phone and/or mobile</small>
            </p>
          </label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "mobile")}
              value={practice.mobile}
              type="text"
              placeholder="Mobile"
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>Email</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "email")}
              value={practice.email}
              type="email"
              placeholder="Email"
            />
          </div>
        </div>

        <h5>Address</h5>
        <div className="md-body1 form-field">
          <label>Address *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "address1")}
              value={practice.address1}
              type="text"
              placeholder=""
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>Address 2</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "address2")}
              value={practice.address2}
              type="text"
              placeholder=""
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>City *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "city")}
              value={practice.city}
              type="email"
              placeholder="City"
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>State/Provence *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "state")}
              value={practice.state}
              type="text"
              placeholder="Province/state"
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>Postal code *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "postCode")}
              value={practice.postCode}
              type="text"
              placeholder="Postal/zip code"
            />
          </div>
        </div>
        <div className="md-body1 form-field">
          <label>Country *</label>
          <div>
            <input
              className="md-input md-title"
              autoComplete="off"
              onChange={e => this.handleInputChange(e, "country")}
              value={practice.country}
              type="text"
              placeholder="Country"
            />
          </div>
        </div>

        <br />
        {this.disabled() ? (
          <p style={{ textAlign: "right" }}>
            Please fille in all required fields (*) and phone or mobile.
          </p>
        ) : null}
        <button
          disabled={this.disabled()}
          className="md-button md-primary right link"
          style={saveStyle}
          onClick={this.save}
        >
          Save
        </button>

        <br />
        <br />
      </div>
    );
  }
}

export default withRouter(RegisterPage)



// WEBPACK FOOTER //
// ./src/components/home/RegisterPage.jsx